import React, { createContext, useContext } from 'react';
import { Cookies } from 'react-cookie';
import useWebSocket from 'react-use-websocket';

const WebSocketContext = createContext();

const WebSocketProvider = ({ children }) => {
    const cookies = new Cookies();
    const { sendJsonMessage, lastJsonMessage } = useWebSocket(`wss://backend.rimglobal.trade/api/MTFiveAccount/ws?authorization=Bearer ${cookies.get('token')}`,
        { retryOnError: true, shouldReconnect: () => true, share: true }
    );

    const sendMessage = (message) => {
        sendJsonMessage(message);
    };
    return (
        <WebSocketContext.Provider value={{ sendMessage, lastJsonMessage }}>
            {children}
        </WebSocketContext.Provider>
    );
};

const useWebSocketContext = () => {
    return useContext(WebSocketContext);
};

export { WebSocketProvider, useWebSocketContext };